import { lazyRetry } from "helpers/lazyRetry";

const Issues_L = lazyRetry(() => import("./Issues"));

export default Issues_L;
